import React, { useState } from "react";
import { useToast } from "../../store/ToastProvider";
import { FlexibleContainer } from "../../components/containers/styledComponents";
import { Icon, IconContainer } from "../../components/visuals/styledComponents";
import { compassLightRed, compassLightGreyBackground } from "../../styles";
import Trashcan from "../../assets/svg/trashcan.svg";
import TrashcanGrey from "../../assets/svg/trashcan_grey.svg";

export const DeletePortfolio = ({
  isIndex,
  portfolioId,
}: DeletePortfolioProps): JSX.Element => {
  const { addToast } = useToast();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = (): void => {
    setIsHovered(true);
  };

  const handleMouseLeave = (): void => {
    setIsHovered(false);
  };

  return (
    <>
      {!isIndex && (
        <FlexibleContainer
          ml={"10px"}
          jc="flex-start"
          c="pointer"
          onClick={(): void => addToast(`removed ${portfolioId}`, "success")}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <IconContainer
            bg={isHovered ? compassLightRed : compassLightGreyBackground}
            style={{ transform: isHovered ? "scale(1.2)" : "scale(1)" }}
          >
            <Icon src={isHovered ? Trashcan : TrashcanGrey} />
          </IconContainer>
        </FlexibleContainer>
      )}
    </>
  );
};

export type DeletePortfolioProps = {
  isIndex: boolean;
  portfolioId: string;
};
